import { useQueryClient, type QueryState } from '@tanstack/react-query';

export function useQueryClientState(key: string[]): QueryState | undefined {
  const queryClient = useQueryClient();
  return queryClient.getQueryState(key);
}
